import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-feature-list/jb-feature-list.css.ts
var jb_feature_list_css_default = i`ul{font-family:var(--theme-font-regular-family, VerlagSSmforBaerVar, Tahoma, sans-serif);font-weight:var(--theme-font-regular-weight, 400)}ul{font-size:var(--theme-typo-body-sm-highlight-desktop-fontsize, 0.813rem);font-weight:var(--theme-typo-body-sm-highlight-fontweight, var(--theme-font-regular-weight, 400));line-height:var(--theme-typo-body-sm-highlight-desktop-lineheight, 1.25rem)}.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}ul{list-style-type:none;padding-block-end:var(--theme-spacing-2xs)}ul li{align-items:center;column-gap:var(--theme-spacing-2xs);display:flex;flex-direction:row;margin:0;padding-block-start:var(--theme-spacing-base)}`;

export {
  jb_feature_list_css_default
};
